












































































































import { Component, Vue, Prop } from "vue-property-decorator";
import TextCoverNew from './textCoverNew.vue';
import TextStartNew from './textStartNew.vue';
import TextMiddle from './textMiddle.vue'
import TextEndNew from './textEndNew.vue';
import TextPackUp from './textPackUp.vue'
import {PopSettingsVO, TFormSaveDetailRequest} from "@/model/FormWheel";
import { getFontFaceList } from "@/utils/getFontFaceList";
import { getVueAppUploadApi } from "@/services/util";
import { DISABLE_CUSTOM_STEP_TPLID, isOnlyNewUserTemplate } from "@/utils/experiment";
import { getQueryVariable } from "@/services/api";
import { getFormPageValues, isMiddlePage } from '../../utils/stepPages';
import { isFullscreenBackgroundPopup } from '@/views/wheelOfFortune/utils/fullscreenBackgroundLayout';


@Component({
  components: {
    'text-cover': TextCoverNew,
    'text-start-new': TextStartNew,
    'text-middle': TextMiddle,
    'text-end-new': TextEndNew,
    'text-pack-up': TextPackUp,
  },
})
export default class wheelOfFortuneText extends Vue {
  @Prop(String)
  activePageSetting!:string;

  @Prop(Number)
  triggerEventType!:any

  @Prop(Object)
  formData!:TFormSaveDetailRequest<PopSettingsVO>;

  @Prop(Array)
  countryList!:any

  @Prop({ type: String, default: 'success' })
  subscribeStatus!: string

  @Prop(Array)
  pageSettings!:any

  @Prop({ type: Object, default: () => ({}) })
  optimizerFirstStepContext!: Record<string, any>

  @Prop({ type: Boolean, default: false })
  optimizerReadOnly!: boolean

  predefineColors = [
    '#ff4500',
    '#ff8c00',
    '#ffd700',
    '#90ee90',
    '#00ced1',
    '#1e90ff',
    '#c71585',
    '#f1b859',
    '#f4994b',
    '#d7394d',
    '#dd5b46',
    '#f7d69e',
    '#ffffff'
  ]

  get enableOnlyNewUserCustomStep() {
    const templateId = String(getQueryVariable('templateid') || this.formData?.templateId || '');
    return isOnlyNewUserTemplate(templateId);
  }

  get enableCustomStep() {
    if ([3, 5, 6].includes(this.triggerEventType as number)) {
      return false;
    }
    const templateId = String(getQueryVariable('templateid') || this.formData?.templateId || '');
    return !DISABLE_CUSTOM_STEP_TPLID.includes(templateId);
  }

  get isMiddlePageSetting() {
    return isMiddlePage(this.activePageSetting);
  }

  get formPages() {
    return getFormPageValues(this.pageSettings || []);
  }

  public fontFaceList = getFontFaceList([
    {
      name: 'Arial',
      value: 'Arial, sans-serif',
      original: true
    },
    {
      name: 'Courier New',
      value: 'Courier New, monospace',
      original: true
    },
    {
      name: 'Georgia',
      value: 'Georgia, serif',
      original: true
    },
    {
      name: 'Times New Roman',
      value: 'Times New Roman, serif',
      original: true
    },
    {
      name: 'Trebuchet MS',
      value: 'Trebuchet MS, sans-serif',
      original: true
    },
    {
      name: 'Verdana',
      value: 'Verdana, sans-serif',
      original: true
    }
  ]);

  // 上传图片地址
  public uploadUrl = getVueAppUploadApi() + "/upload/formImage";

  async created(): Promise<void> {
  }





  //start
  changeTextStart(e:any){
    this.$emit('change',e)
  }
  changeTextEnd(e:any){
    this.$emit('change',e)
  }
  changeTextPackUp(e:any){
    this.$emit('change',e)
  }


  /**
   * 下一步
   */
  nextStep() {
    // this.SettingValid()
    if (!isFullscreenBackgroundPopup(this.formData) && (this.triggerEventType == 0 || this.triggerEventType == 2 || this.triggerEventType == 8)) {
      if (this.enableCustomStep) {
        const firstFormPage = this.formPages[0] || 'start';
        const hasEmailOrMobile = (((this.formData.settings as any) || {})[firstFormPage] || []).some(
          (item: any) => item.type === 'Email' || item.type === 'Mobile Number'
        );
        const label = this.pageSettings.find((item: any) => item.value === firstFormPage)?.label;
        if (!hasEmailOrMobile) {
          this.$message.error(this.$tx('form.edit.err.needContact', '{{label}}手机号或者邮箱，至少有一个属性被添加', { label: label || '' }));
          return;
        }
      } else if(!this.formData.settings.start.length){
        this.$message.warning(this.$tx('form.edit.err.needRequiredContact', '您未设置用户邮箱或手机号为必填，将导致未填写邮箱或手机号的用户信息无法保存，请添加手机号或邮箱后再次保存'))
        return;
      }
    }

    // 校验第三方登录的 Client ID 是否已填写
    if (this.activePageSetting === 'start' && this.$refs.textStart) {
      const textStartRef = this.$refs.textStart as any;
      if (textStartRef.validateAuthList && !textStartRef.validateAuthList()) {
        return; // 校验失败，阻止继续执行
      }
    }

    this.$emit('nextStep')
  }

  /**
   * 上一步
   */
  backStep() {
    this.$emit('backStep')
  }

  /**
   * 取消
   */
  cancel() {
    this.$emit('cancel')
  }

}
